var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.1.8H40.9C19,.8.8,19,.8,40.9v358.2c0,21.9,18.2,40.1,40.1,40.1h358.2c21.9,0,40.1-18.2,40.1-40.1V40.9c-.1-21.9-18.3-40.1-40.1-40.1ZM337.1,236.4l-182.1,105.6c-6.1,3.6-14.6-1.2-14.6-8.5V123.4c0-7.3,7.3-12.1,14.6-8.5l182.1,105.7c6.1,3.6,6.1,12.1,0,15.8h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.e846dbf601788f7bc5d388257871fcc2.svg";
export { ForwardRef as ReactComponent };